(function () {
  /* SLIDESHOW START */
  function initSlideshows(scope) {
    (scope || document).querySelectorAll('[data-slideshow]').forEach(function (root) {
      if (root.__ready) return;
      root.__ready = true;
      var slides = root.querySelectorAll('[data-slide-item]');
      var dots = root.querySelectorAll('[data-dot]');
      if (slides.length < 2) return;
      var idx = 0, timer = null;
      var ms = parseInt(root.getAttribute('data-interval'), 10) || 6000;
      var auto = root.getAttribute('data-autoplay') === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      function go(n) {
        idx = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === idx); s.setAttribute('aria-hidden', k === idx ? 'false' : 'true'); });
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === idx); d.setAttribute('aria-current', k === idx ? 'true' : 'false'); });
      }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function start() { stop(); if (auto) timer = setInterval(function () { go(idx + 1); }, ms); }
      var prev = root.querySelector('[data-prev]'), next = root.querySelector('[data-next]');
      if (prev) prev.addEventListener('click', function () { go(idx - 1); start(); });
      if (next) next.addEventListener('click', function () { go(idx + 1); start(); });
      dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-dot'), 10)); start(); }); });
      root.addEventListener('mouseenter', stop); root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop); root.addEventListener('focusout', start);
      var x0 = null;
      root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      root.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 50) { go(idx + (dx < 0 ? 1 : -1)); start(); }
        x0 = null;
      });
      root.addEventListener('shopify:block:select', function (e) { var n = Array.prototype.indexOf.call(slides, e.target); if (n > -1) go(n); stop(); });
      root.addEventListener('shopify:block:deselect', start);
      go(0); start();
    });
  }
  initSlideshows();
  document.addEventListener('shopify:section:load', function (e) { initSlideshows(e.target); });
  /* SLIDESHOW END */

  // Mobile navigation
  var toggle = document.querySelector('[data-nav-toggle]');
  var nav = document.querySelector('[data-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.classList.contains('is-open')) {
        nav.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.focus();
      }
    });
  }

  // Collection sorting
  var sort = document.querySelector('[data-sort]');
  if (sort) {
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  // Product gallery
  var gallery = document.querySelector('[data-gallery]');
  function showSlide(i) {
    if (!gallery || i < 0) return;
    var slides = gallery.querySelectorAll('[data-slide]');
    var thumbs = gallery.querySelectorAll('[data-thumb]');
    if (!slides[i]) return;
    slides.forEach(function (s, n) { s.classList.toggle('is-active', n === i); });
    thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
  }
  if (gallery) {
    gallery.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () { showSlide(parseInt(t.getAttribute('data-thumb'), 10)); });
    });
  }

  // Product variant picker
  var form = document.getElementById('product-form');
  var dataEl = document.querySelector('[data-variants]');
  if (form && dataEl) {
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var selects = form.querySelectorAll('[data-option]');
    var idInput = form.querySelector('[data-variant-id]');
    var addBtn = form.querySelector('[data-add]');
    var priceNow = document.querySelector('[data-price-now]');
    var priceWas = document.querySelector('[data-price-was]');

    var update = function () {
      var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
      var match = variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === chosen[i]; });
      })[0];
      if (!match) {
        addBtn.disabled = true;
        addBtn.textContent = 'Unavailable';
        return;
      }
      idInput.value = match.id;
      priceNow.textContent = match.price;
      if (match.compare) { priceWas.textContent = match.compare; priceWas.hidden = false; }
      else { priceWas.hidden = true; }
      addBtn.disabled = !match.available;
      addBtn.textContent = match.available ? 'Add to cart' : 'Sold out';
      showSlide(match.media);
      var url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url.toString());
    };
    selects.forEach(function (s) { s.addEventListener('change', update); });
  }
})();

(function () {
  document.querySelectorAll('[data-slideshow]').forEach(function (root) {
    var slides = root.querySelectorAll('[data-slide-item]');
    if (!slides.length) return;
    var dots = root.querySelectorAll('[data-dot]');
    var pauseBtn = root.querySelector('[data-pause]');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoplay = root.getAttribute('data-autoplay') === 'true' && !reduce && slides.length > 1;
    var interval = parseInt(root.getAttribute('data-interval'), 10) || 7000;
    var idx = 0, timer = null, userPaused = false, hoverPaused = false;

    function playVideos(i) {
      slides.forEach(function (s, n) {
        var v = s.querySelector('video');
        if (!v) return;
        if (n === i) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else { v.pause(); }
      });
    }
    function go(i) {
      idx = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === idx); });
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === idx); });
      playVideos(idx);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      stop();
      if (autoplay && !userPaused && !hoverPaused && !document.hidden) {
        timer = setInterval(function () { go(idx + 1); }, interval);
      }
    }

    var prev = root.querySelector('[data-prev]'), next = root.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function () { go(idx - 1); start(); });
    if (next) next.addEventListener('click', function () { go(idx + 1); start(); });
    dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n); start(); }); });
    if (pauseBtn) {
      pauseBtn.addEventListener('click', function () {
        userPaused = !userPaused;
        root.classList.toggle('is-paused', userPaused);
        pauseBtn.setAttribute('aria-label', userPaused ? 'Play slideshow' : 'Pause slideshow');
        start();
      });
    }
    root.addEventListener('mouseenter', function () { hoverPaused = true; stop(); });
    root.addEventListener('mouseleave', function () { hoverPaused = false; start(); });
    root.addEventListener('focusin', function () { hoverPaused = true; stop(); });
    root.addEventListener('focusout', function () { hoverPaused = false; start(); });
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { go(idx - 1); start(); }
      if (e.key === 'ArrowRight') { go(idx + 1); start(); }
    });

    // Theme editor: jump to the slide being edited
    root.addEventListener('shopify:block:select', function (e) {
      for (var n = 0; n < slides.length; n++) { if (slides[n] === e.target) { go(n); break; } }
      userPaused = true; stop();
    });
    root.addEventListener('shopify:block:deselect', function () { userPaused = false; start(); });

    playVideos(0);
    start();
  });
})();
